import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { view01ImageOptions } from './views/View01'

class X43Mast extends Component {
    constructor(props) {
        super(props);
        this.handleMastAndBoomChange = this.handleMastAndBoomChange.bind(this);
    }

    handleMastAndBoomChange(newValue) {
        let configuration = this.props.configuration;
        configuration.MastAndBoom = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = view01ImageOptions;

        let image = (
            <TransomConfigurator colorMultiplier={0.75} name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 2895, height: 780 }} transform={
                [
                    0.057336, -0.004583, 0, -0.00004,
                    0.013769, 0.142082, 0, 0.000077,
                    0, 0, 1, 0,
                    214, 380, 0, 1
                ]}>
                <ConfiguratorImage boat="X4_3" configuration={this.props.configuration} options={imageOptions} />
            </TransomConfigurator>
        );

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Mast & Boom' /></h1>

                    <h2><Trans defaults='Finish' /></h2>

                    <RadioGroup options={this.props.mastAndBoomOptions} value={this.props.configuration.MastAndBoom} onChange={this.handleMastAndBoomChange} />

                    <p><Trans defaults='**for optional furlerboom, please contact your local X-Yachts Dealer.' /></p>

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X43Mast);


// WEBPACK FOOTER //
// ./src/X43/X43Mast.js